import React from 'react';
import packageBottomImg from '../../images/packages/package-bottom.svg';
import styled from 'styled-components';

export const CheckoutPackage = ({ packageInfo, orderNumber }) => {
	const isFull = !packageInfo.isOnlyInternet;

	const Wrapper = styled.div`
		box-shadow: 0px 0px 38px rgba(17, 6, 29, 0.2);
		border-radius: 8px;
		min-width: 300px;
		max-width: 355px;

		@media screen and (max-width: 400px) {
			min-width: 200px;
			max-width: 100%;
		}
	`;
	const PackageCard = styled.div`
		background: #ffffff;
	`;

	/* background-image: url(${packageBottomImg}); */
	const PackageCardBottom = styled.div`
		width: 100%;
		padding: 0;
		margin: 0;
		background-image: url(${packageBottomImg});
		background-position: 100% 100%;
		background-repeat: no-repeat;
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
		background-color: rgba(17, 6, 29, 0.1);
	`;

	const PackageHeader = styled.div`
		background: #f4f5fa;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
	`;

	return (
		<>
			<div className="package">
				<Wrapper>
					{/* <div className='row w-100 d-flex justify-content-center align-items-center'> */}
					<PackageHeader className="text-center d-flex justify-content-center flex-column">
						<h3 className="mt-3">{packageInfo.internalTitle}</h3>
						<p>Поръчка: #{orderNumber}</p>
					</PackageHeader>
					{/* </div> */}
					<PackageCard className="pt-2 pb-5 col-12">
						<div className="row py-2 mx-md-2">
							{isFull && (
								<div className="row w-100 b-bottom-faded d-flex justify-content-between align-items-center">
									<p className="m-1">
										<span className="icon package green-monitor"></span>
										Цифрови канали
									</p>
									<p className="m-1">
										<span className="text-blue">
											{packageInfo.tvChannels}
										</span>
										{/* <button className='clear ml-1 p-0' onClick={() => setShowChannels(true)}>
                <span className='icon package view-channels'></span>
              </button> */}
									</p>
								</div>
							)}

							<div
								className={
									'row w-100 d-flex justify-content-between align-items-center ' +
									(isFull && 'b-bottom-faded')
								}
							>
								<p className="m-1">
									<span className="icon package green-wifi"></span>
									Интернет скорост
								</p>
								<p className="m-1">
									<span className="text-blue">
										{packageInfo.internetSpeed}
									</span>
								</p>
							</div>

							{isFull && (
								<>
									<div className="row w-100 d-flex justify-content-between align-items-center b-bottom-faded">
										<p className="m-1">
											<span className="icon package green-modem"></span>
											IPTV приемник (STB)
										</p>
										<p className="m-1">
											<span className="text-blue">
												{packageInfo.hdFetcher}
											</span>
										</p>
									</div>
								</>
							)}

							<div
								className={
									'row w-100 d-flex justify-content-between align-items-center ' +
									(isFull && 'b-bottom-faded')
								}
							>
								<p className="m-1">
									<span className="icon package green-calendar"></span>
									Срок на договора
								</p>
								<p className="m-1">
									<span className="text-blue">
										{parseInt(packageInfo.duration) * 12 + 'м.'}
									</span>
								</p>
							</div>

							{isFull && (
								<>
									<div className="row w-100 d-flex justify-content-between align-items-center">
										<p className="m-1">
											<span className="icon package green-zap"></span>
											Допълнителни екстри
										</p>
									</div>
								</>
							)}

							<div className="row w-100 py-2 d-flex justify-content-between align-items-center b-bottom-faded">
								<h3>Общо</h3>
								<div className="row pt-3 mx-2 d-flex justify-content-center align-items-center">
									<div className="col-6 row p-0">
										<div className="col-6 p-0 d-flex justify-content-end align-items-center">
											<h3 className="price">
												<span className="text-blue">
													{packageInfo.getPriceMain()}
												</span>
											</h3>
										</div>
										<div className="col-6 p-0 m-0 row d-flex justify-content-start ">
											<h3 className="price-coins">
												<span className="text-blue">
													{packageInfo.getPriceCoins()}
												</span>
											</h3>

										</div>
									</div>
								</div>
							</div>
						</div>
					</PackageCard>

					<PackageCardBottom>
						<div style={{ height: '12px' }} />
					</PackageCardBottom>
				</Wrapper>
			</div>
		</>
	);
};

